const { h, render, Component } = require('preact');
const LocalGoodsTable = require('./local_goods_table')
const GetawaysBookingTable = require('./getaways_booking_table')
const GetawaysVoucherTable = require('./getaways_voucher_table')
const CardInfo = require('./card_info')
const TravelerInfo = require('./traveler_info')

class DetailTable extends Component {
  constructor(props) {
    super(props);
  }

  getCardAndTravelInfo() {
    return (
      <div>
      <CardInfo orderDetails={this.props.orderDetails} />
      <TravelerInfo orderDetails={this.props.orderDetails} />
      </div>
    )
  }

  render() {
    let detailTable;
    if (this.props.orderDetails.DEAL_TYPE == "GETAWAYS_BOOKING"){
      detailTable = <GetawaysBookingTable orderDetails={this.props.orderDetails} />
    }
    else if (this.props.orderDetails.DEAL_TYPE == "GETAWAYS_VOUCHER"){
      detailTable = <GetawaysVoucherTable orderDetails={this.props.orderDetails} />
    }
    else{
      detailTable = <LocalGoodsTable orderDetails={this.props.orderDetails} />
    }

    let orderDetails = this.props.orderDetails;
    return (
      <div class="order-details">
        <p class="merchant-name">{orderDetails.merchant.name}</p>
        {detailTable}
        {!this.props.orderDetails.isGift ? (this.getCardAndTravelInfo()) : null}
      </div>
    );
  }
}
module.exports = DetailTable
